import type { UseQueryResult } from '@tanstack/react-query'

import { useQuery } from '@tanstack/react-query'

import http from '../../../lib/http'

export interface Alert extends Record<string, unknown>{
  id: string
  patient_id: string
  patient_first_name: string
  patient_last_name: string
  created_at: string
  status: AlertStatuses
  status_history: StatusHistory[]
  title: string
  client_name: string
  meta: {
    careTeam: string
  }
}

export interface StatusHistory {
  end: string
  start: string
  status: string
}

export type AlertStatuses = 'l1' | 'l2' | 'l3' | 'l4' | 'l5'

export function useAlerts (): UseQueryResult<Alert[], unknown> {
  return useQuery<Alert[], unknown, Alert[], ['alerts']>({
    queryKey: [ 'alerts' ],
    async queryFn (): Promise<Alert[]> {
      const data = await http.getRequest<Alert[]>('/alerts', {})
      return data.sort((a, b) => a?.created_at?.localeCompare(b?.created_at))
    },
    refetchOnWindowFocus: false
  })
}
